// extracted by mini-css-extract-plugin
export default {"appContainer":"_AOiLX0b","appBody":"zsUKMuHI"};